export var CountdownStyle;
(function (CountdownStyle) {
    CountdownStyle["None"] = "none";
    CountdownStyle["Solid"] = "solid";
    CountdownStyle["Outline"] = "outline";
})(CountdownStyle || (CountdownStyle = {}));
export var CountdownKind;
(function (CountdownKind) {
    CountdownKind["Date"] = "date";
    CountdownKind["Time"] = "time";
})(CountdownKind || (CountdownKind = {}));
export var CountdownTimezone;
(function (CountdownTimezone) {
    CountdownTimezone["Visitor"] = "visitor";
    CountdownTimezone["Hotel"] = "hotel";
})(CountdownTimezone || (CountdownTimezone = {}));
//# sourceMappingURL=countdown.types.js.map